






















































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { domain, Company, Branch, Terminal, VueRoot, User, PartialPermission } from "@/domain";
import QuickSnack from "@/components/QuickSnack.vue";
import QrCodeImg from "@/components/QrCodeImg.vue";
import CompanyEdit from "@/components/CompanyEdit.vue";
import * as uiUtil from "@/uiUtil";
import * as format from "@/util/format";
import * as excel from "@/util/excel";
import { fileDateTimeString, isEmpty, log, logError, promiseEnd, toBase64Url, toNumber } from "@/util";
import { selectCompany } from "@/domain/store_util";

interface StatusStyle {
  icon: string;
  color: string;
  text: string;
  name?: string;
}
type ChildrenItem = Terminal & {
  originalName: string;
  type: string;
  key?: string;
  id: string;
  isEmpty: boolean;
  name: string;
  branch: Branch;
  status?: StatusStyle;
  qrError?: boolean;
  qrLoading?: boolean;
  qrLoaded?: boolean;
  qrContent?: string;
};
type BranchItem = Branch & {
  originalName: string;
  type: string;
  key: string;
  terminalCount: number;
  children: ChildrenItem[] | null;
  status?: StatusStyle;
  active: boolean;
};

@Component({
  components: { QuickSnack, QrCodeImg, CompanyEdit }
})
export default class CompanyInfo extends Vue {
  selectedTreeArr: (BranchItem | ChildrenItem)[] = [];
  openTreeArr: ChildrenItem[] = [];
  treeSearch = "";
  editedTerminalStatus: "none" | "editing" | "saving" = "none";
  editedTerminalName = "";

  removingCompany: Company | null = null;
  disableCopyUrl = false;
  showInactive = false;
  selectedBranch: Branch | null = null;

  get lang() {
    return this.$store.state.lang.data;
  }

  get langKey() {
    return this.$store.state.lang.key as string;
  }

  get lastRemoteError(): string | null {
    if (this.$store.state.lastError) {
      return this.lang.errorData;
    }
    return null;
  }

  get currentCompanyLoading(): boolean {
    return this.$store.state.selectedCompanyLoading;
  }

  get currentCompany(): Company | null {
    return this.$store.state.selectedCompany;
  }

  get isMobile(): boolean {
    return (this.$root as VueRoot).isMobile;
  }

  get companyEditDialog() {
    return this.$refs.companyEditDialog as CompanyEdit;
  }

  get isLoading(): boolean {
    return this.currentCompanyLoading;
  }

  get currentUser(): User {
    return this.$store.state.currentUser || {};
  }

  get userPermission(): PartialPermission {
    return this.$store.getters.userPermission;
  }

  get isAdmin() {
    return this.userPermission.isAdminOfAny || this.currentUser.isToken || this.currentUser.isGlobalAdmin;
  }

  get selected(): ChildrenItem | null {
    if (this.selectedTreeArr && this.selectedTreeArr.length > 0 && this.selectedTreeArr[0].type === "term") {
      this.selectedBranch = null;
      return this.selectedTreeArr[0] as ChildrenItem;
    }
    return null;
  }

  showBranch(item: BranchItem, open: boolean) {
    if (item.type == "branch" && !open) {
      this.selectedTreeArr.push(item);
      this.selectedBranch = this.currentCompany?.branches?.find((b) => b.id == item.id) ?? null;
    } else {
      this.selectedBranch = null;
    }
  }

  formatBoolean(value: boolean | null): string {
    if (value == true) return "Si";
    if (value == false) return "No";
    return "-";
  }

  get headers() {
    return [
      { text: "ID", value: "id", align: "start" },
      { text: "Name", value: "name" },
      { text: "Code", value: "code" },
      { text: "CSB", value: "csb" },
      { text: "Status", value: "active", align: "center" }
    ];
  }

  get treeItems(): BranchItem[] {
    if (!this.isLoading && this.currentCompany && this.currentCompany.branches) {
      const branchItems = this.currentCompany.branches.map((branch) => {
        const item: BranchItem = {
          type: "branch",
          key: "b" + branch.id,
          ...branch,
          originalName: branch.name,
          terminalCount: branch.terminals?.length || 0,
          children: this.fetchTerminals(branch),
          active: true
        };
        item.status = this.getBranchStatus(item);
        if (item.status.color === "grey") item.active = false;
        return item;
      });
      if (this.showInactive) return branchItems;
      else {
        branchItems
          .filter((b) => b.active === true)
          .forEach((c) => {
            if (c.children) c.children = c.children.filter((d) => d.status?.name !== "disconnected");
          });
        return branchItems.filter((b) => b.active === true);
      }
    }
    return [];
  }

  get snack(): QuickSnack {
    return this.$refs.snack as QuickSnack;
  }

  makeConfigUrl() {
    if (!this.selected) return;
    this.disableCopyUrl = true;
    const config = {
      branchID: this.selected.branch.id,
      tcod: this.selected.tcod,
      terminalID: this.selected.code
    };
    const data = toBase64Url(JSON.stringify(config));
    const url = `https://my.paytef.es/terminalQrConfig?data=${data}`;
    navigator.clipboard.writeText(url);
    setTimeout(() => {
      this.disableCopyUrl = false;
    }, 2000);
  }

  async mounted() {
    if (this.$route.query && this.$route.query.branchID && this.$route.query.companyID) {
      await selectCompany(this.$store, this.$route.query.companyID);
      this.showInactive = true;
      this.$nextTick(() => {
        this.selectTerminal(
          toNumber(this.$route.query.branchID),
          this.$route.query.terminalID as string | null,
          this.$route.query.tcod as string | null
        );
      });
    }
    if (!this.currentCompany && !this.currentCompanyLoading) {
      this.$router.push("/companyCatalog");
    }
  }

  cmdShowCompanyEdit() {
    if (this.currentCompany) this.companyEditDialog.showCompanyID(this.currentCompany.id);
  }

  getBranchStatus(branch: BranchItem): StatusStyle {
    const counts: { [key: string]: number } = {
      online: 0,
      disconnected: 0,
      failing: 0
    };
    let text = "Terminales: " + branch.terminalCount;
    if (!isEmpty(branch.terminals)) {
      branch.children?.forEach((t) => {
        const stName = t.status?.name;
        if (stName) {
          counts[stName] = counts[stName] + 1;
        }
      });
      text += counts.online === 0 ? "" : " - En línea: " + counts.online;
      text += counts.disconnected === 0 ? "" : " - Desconectadas: " + counts.disconnected;
      text += counts.failing === 0 ? "" : " - Con fallas: " + counts.failing;
    }
    return {
      icon: "store",
      color: branch.terminalCount > counts.disconnected ? "primary" : "grey",
      text
    };
  }

  fetchTerminals(branch: Branch): ChildrenItem[] | null {
    if (branch.terminals) {
      if (branch.terminals.length === 0) {
        return [
          {
            type: "empty",
            id: "x" + branch.id,
            isEmpty: true,
            originalName: "",
            name: "No hay terminales disponibles.",
            branch,
            code: "",
            tcod: "",
            activationTimestamp: "",
            lastConnection: "",
            releaseTimestamp: "",
            connectedPinPads: "",
            delayMinutes: "",
            machineAndLocalIP: "",
            lastIP: "",
            unlockCode: "",
            serialNumber: null,
            device: null
          }
        ];
      }
      return branch.terminals.map((term) => {
        return {
          type: "term",
          key: "b" + branch.id + "t" + term.code,
          isEmpty: false,
          ...term,
          originalName: term.name,
          name: term.name + "||" + term.tcod + "||" + (term.serialNumber ?? ""),
          id: term.code,
          status: this.getTerminalStatus(term),
          qrError: false,
          qrLoading: false,
          qrLoaded: false,
          qrContent: "",
          branch
        };
      });
    }
    return null;
  }

  showEditTerminalName() {
    this.editedTerminalName = this.selected?.originalName ?? "";
    this.editedTerminalStatus = "editing";
  }

  async saveEditedTerminalName() {
    this.editedTerminalStatus = "saving";
    try {
      const terminal = this.selected;
      if (!terminal || !terminal.tcod || !this.currentCompany) {
        return;
      }
      if (this.editedTerminalName === terminal.originalName) {
        this.resetEditedTerminalName();
        return;
      }
      await domain.backend.renameTerminal({
        branchID: terminal.branch.id,
        companyID: this.currentCompany.id,
        tcod: terminal.tcod,
        newName: this.editedTerminalName
      });
      this.resetEditedTerminalName();
      await this.$store.dispatch("refreshCompany");
      setTimeout(() => {
        this.selectTerminal(terminal.branch.id, terminal.code, null);
      }, 2000);
      this.editedTerminalStatus = "none";
    } catch (ex) {
      this.snack.show(this.lang.failedAction + ". " + (ex as Error).message, "error");
      this.editedTerminalStatus = "editing";
    }
  }

  selectTerminal(branchID: number, code: string | null, tcod: string | null) {
    const branchItem = this.treeItems.find((b) => b.id == branchID);
    if (!branchItem) {
      console.log("Can't find branch");
      return;
    }
    this.openTreeArr.push(branchItem as unknown as ChildrenItem);
    let terminal: ChildrenItem | null = null;
    if (!code && !tcod) {
      if (branchItem.children && branchItem.children.length > 0) {
        terminal = branchItem.children[0];
      }
    } else {
      terminal = branchItem.children?.find((t) => (!!code && t.code == code) || (!!tcod && t.tcod == tcod)) ?? null;
    }
    if (!terminal) return;
    this.selectedTreeArr.push(terminal);
  }

  resetEditedTerminalName() {
    this.editedTerminalStatus = "none";
  }

  @Watch("selected")
  refreshQRContent(item: ChildrenItem) {
    this.resetEditedTerminalName();
    if (!!item && !item.qrLoaded) {
      item.qrLoading = true;
      item.qrError = false;
      domain.backend
        .getTerminalQR({
          branchID: item.branch.id,
          terminalID: Number(item.id),
          tcod: item.tcod || "",
          language: this.langKey
        })
        .then((qr) => {
          log("QR=" + uiUtil.packQRData(qr));
          item.qrLoading = false;
          item.qrLoaded = true;
          item.qrContent = uiUtil.packQRData(qr);
        })
        .catch((ex) => {
          item.qrLoading = false;
          item.qrError = true;
          logError("Error obteniendo código QR", ex);
        });
    }
  }

  getTerminalStatus(term: Terminal): StatusStyle {
    if (!isEmpty(term.delayMinutes)) {
      const delay = toNumber(term.delayMinutes);
      if (!term.lastConnection || delay > 65) {
        return {
          icon: "mdi-lan-disconnect",
          color: "grey",
          text: "Desconectado (latencia de " + term.delayMinutes + " minutos)",
          name: "disconnected"
        };
      } else if (delay <= 1) {
        return {
          icon: "mdi-lan-connect",
          color: "success",
          text: "En línea",
          name: "online"
        };
      }
    }
    return {
      icon: "mdi-lan-pending",
      color: "warning",
      text: "Conexión irregular",
      name: "failing"
    };
  }

  @Watch("openTreeArr")
  onOpenChanged(newVal: ChildrenItem[], oldVal: ChildrenItem[]) {
    if (isEmpty(newVal) || isEmpty(oldVal) || newVal.length <= oldVal.length) {
      return;
    }
    let newOpened: ChildrenItem | null = null;
    newVal.forEach((o) => {
      if (!oldVal.find((oldo) => oldo.id === o.id)) {
        newOpened = o;
      }
    });
    if (newOpened) {
      this.$nextTick(() => {
        if (newOpened) {
          this.openTreeArr = [newOpened];
        }
      });
    }
  }

  cmdExportExcel() {
    if (this.currentCompany && this.currentCompany.branches) {
      const headers = [
        excel.header("Comercio", "companyName", 20),
        excel.header("Oficina", "branchName", 20),
        excel.header("Terminal", "name", 20),
        excel.header("TCOD", "tcod", 15),
        excel.header("Activación", "activationTimestamp", 20),
        excel.header("Última conexión", "lastConnection", 20),
        excel.header("Release", "releaseTimestamp", 20),
        excel.header("Dispositivos conectados", "connectedPinPads", 21),
        excel.header("Latencia (minutos)", "delayMinutes", 19),
        excel.header("Máquina e IP Local", "machineAndLocalIP", 25),
        excel.header("Última IP", "lastIP", 17)
      ];
      const data: { [key: string]: unknown }[] = [];
      this.currentCompany.branches.forEach((branch) => {
        if (branch.terminals) {
          branch.terminals.forEach((term) => {
            data.push({
              companyName: this.currentCompany?.name,
              branchName: branch.name,
              ...term,
              activationTimestamp: format.printTimestamp(term.activationTimestamp),
              lastConnection: format.printTimestamp(term.lastConnection),
              releaseTimestamp: format.printTimestamp(term.releaseTimestamp)
            });
          });
        }
      });
      const filename = `Datos del comercio ${this.currentCompany.name} ${fileDateTimeString()}`;
      excel.writeSpreadsheet(filename, "Comercios", headers, data).catch((err) => {
        logError("Error escribiendo excel", err);
        this.snack.show("No se pudo generar el archivo", "error");
      });
    }
  }

  cmdRetrySelectCompany() {
    promiseEnd(this.$store.dispatch("refreshCompany"));
  }

  async cmdResetCompany() {
    await this.$store.dispatch("selectCompany", null);
    this.$router.push("/companyCatalog");
  }

  cmdConnectionDetails() {
    this.goToPage("/connectionstatus");
  }

  cmdTransactionDetails() {
    this.goToPage("/transactionquery");
  }

  cmdVendingConfig() {
    this.goToPage("/vendingConfig");
  }

  goToPage(path: string) {
    if (!this.selected) return;
    uiUtil.routePush(this, {
      path: path,
      query: {
        companyID: (this.currentCompany?.id || "").toString(),
        branchID: this.selected.branch.id.toString(),
        terminalID: this.selected.code,
        tcod: this.selected.tcod
      }
    });
  }
}
